import React from "react";
import { DateTimePicker } from "material-ui-pickers";
import { withTheme } from "@material-ui/core/styles";

const Picker = withTheme()(DateTimePicker);

export default function({ input: { onChange, ...inputRest }, ...rest }) {
  return <Picker onChange={onChange} {...inputRest} {...rest} />;
}
